(ns web3.screens.service-provider
  (:require [web3.components.drawer :as drawer]
            [web3.i18n :as i]
            [web3.queries.service-provider :as q-provider]
            [web3.forms.fields :as fields]
            [web3.utils :as utils]
            [web3.routing.core :as routing]
            [reagent.core :as r]
            [web3.components.widgets :as widgets]
            [web3.persistence.schema :as schema]
            [web3.forms.validation :as validation]
            [web3.persistence.graphql :as g]
            [web3.constants :as constants]
            [web3.persistence.deletions :as deletions]
            [web3.view :as v]
            [goog.string :as gstring]
            [web3.env :as env]
            [web3.persistence.current-property :as current-property]
            [web3.queries.root :as q-root]
            [web3.icons.shapes :as shapes]))

(defn first-phone [{:as provider :keys [mobilePhone officePhone iphonePhone otherPhone homePhone]}]
  (first (keep utils/some-str [mobilePhone officePhone iphonePhone otherPhone homePhone])))

(defn provider-summary [{:as provider
                         :keys [firstName
                                lastName
                                professionName
                                companyName
                                id]}]
  (let [phone-number (-> provider first-phone schema/decode-phone-number)
        name-to-render (if (or (not (empty? firstName))
                               (not (empty? lastName)))
                         (str firstName " " lastName)
                         companyName)]
   [:div
    {:key id}
    [:a.cursor-pointer.flex.items-stretch.flex-none.text-black.hover-opacity-parent
     {:href (routing/path-for [:service-providers/detail :service-provider-id id])}
     [:div.flex.items-center.flex-auto.hover-appear-parent.pad-left-3
      [:div.flex-auto.pad-v-3
       name-to-render
       [:div.text-dark-gray.flex
        professionName
        [:div.flex-auto]
        (if-not (empty? phone-number)
          phone-number
          (gstring/unescapeEntities "&nbsp;"))]]]
     [:div.flex.items-center.cursor-pointer.pad-right-3.pad-left-4.hover-opacity-child
      shapes/chevron-right]]
    drawer/drawer-list-spacer]))

(defn get-value
  "Props will contain :value for controlled fields, and :persisted-value for self-contained persisted fields."
  [props]
  (or (:value props)
      (:persisted-value props)))

(defn service-provider-form
  ([edit? make-props]
   (service-provider-form edit? make-props {}))
  ([edit? make-props opts]
   (let [{:keys [parent-component]} opts
         {parent-state :state} parent-component
         make-props (comp (partial merge {:container {:class "flex-basis-0"}}) make-props)
         field (fn [field-name] ^{:key field-name} [fields/from-schema
                                                    field-name
                                                    (make-props field-name)])]
     [:div.pad-all-3
      (if edit?
        [:div
         [:div.flex
          (field :ServiceProvider/firstName)
          [:div.margin-right-3]
          (field :ServiceProvider/lastName)]
         [:div.flex
          (field :ServiceProvider/companyName)
          [:div.margin-right-3]
          (field :ServiceProvider/professionName)]
         [:div.text-size-13 {:style {:color (:red constants/colors)}}
          (:form-error @parent-state)]]
        (let [[firstName lastName companyName professionName]
              (map (comp get-value make-props)
                   [:ServiceProvider/firstName
                    :ServiceProvider/lastName
                    :ServiceProvider/companyName
                    :ServiceProvider/professionName])]
          [:div.weight-medium.field-border-bottom.pad-bottom-1.pad-top-3.margin-bottom-3
           [:div.text-size-20
            firstName " " lastName]
           (into [:div.text-size-13.line-h-28]
                 (interpose " • " (filter utils/some-str [professionName companyName])))]))

      (doall (map field [:ServiceProvider/website
                         :ServiceProvider/email
                         :ServiceProvider/note
                         :ServiceProvider/homePhone
                         :ServiceProvider/iphonePhone
                         :ServiceProvider/mobilePhone
                         :ServiceProvider/officePhone
                         :ServiceProvider/otherPhone]))])))

#_(service-provider-form (fn [field-name]
                           {:read-only? true
                            :value (get provider (utils/simplify-keyword field-name))}))

(v/defview index
  {:header {:title (i/get :i/service-providers)}}
  []
  (when-let [{:keys [id]} (current-property/get-property)]

    [:<>
     (when (= (:partner/id env/config) "centriq")
       [:<>
        [:div.pad-h-3.pad-v-4.flex.items-center
         [:div.flex-auto
          (i/get :drawer/need-help.title)]
         [widgets/black-button {:key "find a pro"
                                :href constants/find-a-pro-link
                                :class "inline-flex"
                                :target "_blank"
                                :rel "noopener"}
          (i/get :drawer/need-help.label)]]

        drawer/drawer-list-spacer])

     (doall
      (map provider-summary (-> (q-provider/service-providers {:id id})
                                :entity
                                :serviceProviders)))

     [drawer/bottom-button
      {:key "add"
       :href (routing/path-for [:add/service-provider])}
      (i/get :i/add-new-service-provider)]]))

(defn delete-service-provider [provider]
  (deletions/delete-with-confirm
    (merge provider
           {:text-primary (i/get :service-provider/delete.primary)
            :mutate! (partial q-provider/service-provider-delete! (select-keys provider [:id]))
            :snack (i/get :service-provider/delete-complete)
            :redirect (routing/path-for [:service-providers/index])})))

(v/defview detail
  {:header {:title (i/get :i/service-provider-details)
            :content-right [widgets/edit-pencil-drawer [:edit :provider]]}}
  [{:keys [service-provider-id] :as params}]
  (let [edit? (routing/get-query [:edit :provider])
        {:keys [state] :as this} (r/current-component)
        {provider :entity :as query} (q-provider/service-provider {:id service-provider-id})
        {:keys [firstName lastName companyName]} provider
        or-field-map  {:ServiceProvider/firstName firstName
                       :ServiceProvider/lastName lastName
                       :ServiceProvider/companyName companyName}
        id (-> (q-root/me) :me :id)
        read-only? (:readOnly provider)]
    (when read-only?
     (routing/set-query! [:edit :read-only?] read-only?))
    [:div
     [widgets/graphql-state query]
     (service-provider-form
      edit?
      (fn [key]
        (if edit?
          {:persist-value! (fn [component value opts]
                             (if (->> (assoc or-field-map key value)
                                      vals
                                      (every? empty?))
                               (swap! state assoc
                                      :form-error
                                      "Must include First Name, Last Name, or Company Name")
                               (q-provider/service-provider-update!
                                (assoc provider (utils/simplify-keyword key) value)
                                (merge {:component component}
                                       opts))))
           :persisted-value (get provider (utils/simplify-keyword key))}
          {:read-only? true
           :value (get provider (utils/simplify-keyword key))}))
      {:parent-component this})

     [:div.pad-all-3
      (when edit?
        [:div
         [widgets/primary-button
          {:class "border-gray"
           :on-click (partial delete-service-provider provider)}
          (i/get :i/delete)]
         [widgets/black-button
          {:on-click #(routing/set-query! [:edit :provider] nil)
           :class "margin-top-3"}
          (i/get :i/done)]])
      (when (= service-provider-id id)
        [widgets/black-button
         {:class "margin-bottom-3 margin-top-4"
          :on-click #(routing/nav! (routing/path-for [:pro/start]))}
         (i/get :i/edit-pro-profile)])]]))

(v/defview add
  {:header {:title (i/get :i/add-service-provider)}}
  []
  (let [{:keys [state] :as this} (r/current-component)
        {property-id :id} (current-property/get-property)
        or-fields [:ServiceProvider/firstName
                   :ServiceProvider/lastName
                   :ServiceProvider/companyName]
        create-service-provider!
        (fn [^js e]
          (.preventDefault e)
          (let [data (-> @state
                         (assoc :propertyId property-id))
                validations (schema/validate-service-provider data)
                invalid-required-or-fields (every? nil? (map #(% data) or-fields))]
            (swap! state assoc :dirty? true)
            (when invalid-required-or-fields
             (swap! state assoc :form-error (i/to-do "You must include First Name, Last Name, or Company Name")))
            (when-not (or (validation/invalid? validations)
                           invalid-required-or-fields)
              (-> (->> {:component this
                        :on-complete
                        (fn [^js payload]
                          (let [{:keys [id]} (-> payload
                                                 (utils/->clj-map)
                                                 (get-in [:data
                                                          :service-provider-create
                                                          :service-provider]))]
                            (->> (routing/path-for :router/drawer [:service-providers/detail
                                                                   :service-provider-id id]
                                                   :router/form-modal nil)
                                 routing/nav!)))}
                       (q-provider/service-provider-create! data))))))
        ]
    [drawer/frame
     [drawer/body
      [:form
       {:on-submit create-service-provider!}
       [service-provider-form true
        (fn [key]
          {:change-value! #(swap! state assoc key %)
           :value (get @state key)
           :dirty? (:dirty? @state)})
        {:parent-component this}]
       [:div.pad-all-3
        [widgets/graphql-submit-button
         {:label (i/get :i/create)
          :state (g/mutation-state)}]]]]]))
